// extracted by mini-css-extract-plugin
export default {"root":"QBH0EFlBn074U19r_s7T"};